import { Grid, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import FileDataRow from "../../other/FileDataRow/FileDataRow";

function FileWindow(props) {
    const { t } = useTranslation();
    const scrollableDivRef = useRef(null);

    useEffect(() => {
        scrollToPosition();
    }, [props.files]);

    const scrollToPosition = () => {
        scrollableDivRef.current?.scrollTo(0, 0);
    };

    const getWindowNoFilesInfo = () => {
        switch (props.fileType) {
            case "docs":
                return t("window.file_window.no_docs");
            case "certs":
                return t("window.file_window.no_certs");
            default:
                return t("window.file_window.no_files");
        }
    };

    return (
        <div
            ref={scrollableDivRef}
            style={{
                overflow: "auto",
                paddingRight: "5px",
                ...props.fileWindowStyle,
            }}
        >
            {props.files.length > 0 ? (
                <Grid container spacing={1} alignItems="center" justifyContent="flex-start">
                    {props.files.map((file, index) => {
                        return (
                            <Grid item xs={12} sm={12}>
                                <FileDataRow
                                    index={index}
                                    file={file}
                                    onDownload={props.onDownload}
                                    onPreview={props.onPreview}
                                    onUpdateFile={props.onUpdateFile}
                                    onDeleteFile={props.onDeleteFile}
                                    onRefetch={props.onRefetch}
                                    showCreator={props.showCreator}
                                    readOnly={props.readOnly}
                                    canRemoveFiles={props.canRemoveFiles}
                                    showDetailsButton={props.showDetailsButton}
                                    showDownloadButton={props.showDownloadButton}
                                    fileType={props.fileType}
                                    availableDocsRestrictedTypes={
                                        props.availableDocsRestrictedTypes
                                    }
                                    showRevisionButton={props.showRevisionButton}
                                />
                            </Grid>
                        );
                    })}
                </Grid>
            ) : (
                <Grid container direction="column" alignItems="center" justifyContent="center">
                    <Typography variant="subtitle1" color="primary">
                        {" "}
                        {getWindowNoFilesInfo()}{" "}
                    </Typography>
                </Grid>
            )}
        </div>
    );
}

FileWindow.propTypes = {
    files: PropTypes.object,
    fileWindowStyle: PropTypes.object,
};

FileWindow.defaultProps = {
    files: {},
    fileWindowStyle: { height: 400 },
};

export default FileWindow;
